import { Dashicon } from '@wordpress/components';
import Breadcrumbs from "./BreadCrumbs";
import Logo from "./Logo";

export default function Header() {

    const backToResponsiveDashboard = () => {
        window.location.href = responsive_addons_site_builder.res_dash_url;
    }

    return (
        <div className="flex gap-5 min-h-16 items-center justify-between px-10 border-b-[1px] border-border bg-[#2D2C52]">
            <div className="flex gap-5 items-center">
                <Logo />
                <Breadcrumbs />
            </div>
            <div onClick={backToResponsiveDashboard}>
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" className='cursor-pointer'>
                    <path d="M18 6L6 18" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                    <path d="M6 6L18 18" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
            </div>
        </div>
    )
}